import React from "react";

import CustomerLogosSection from "../CustomerLogos";
import ProofStrip from "../ProofStrip";
import { BannerWrapper, HeroStage, HeroGrid, HeroMedia } from "./banner.style";
import TrialDownloadButton from "../../Custom/TrialDownloadButton";
import MediaPlaceholder from "../../Custom/MediaPlaceholder";
import { HERO_VIDEO } from "common/data/launch";
import HeroVideo from "./HeroVideo";
import SeeInAction from "./SeeInAction";
import CasesLink from "./CasesLink";

// The hero button is the one main action of the first screen, so it is larger
// than the START FREE button in the navigation.
const HERO_BUTTON = {
  type: "button",
  fontSize: ["16px", "17px"],
  fontWeight: "700",
  borderRadius: "6px",
  pl: "28px",
  pr: "28px",
  colors: "secondaryWithBg",
  minHeight: "auto",
  height: ["52px", "56px"],
};

const VIDEO_DESCRIPTION_ID = "hero-video-description";

// First screen: the brand kicker (See. Understand.) over the result (Reduce
// AWS costs. Typical savings: 13-44%), one sentence that says where the
// figure comes from with a quiet link to the audit cases, the download button
// with one line of facts, the smaller See in action link to the demo, and the
// film. Everything else that used to stand
// here lives further down the page (GetStarted, PricingPolicy, InteractiveDemo,
// Comparison, FAQ, testimonials; "since 2021" in Partner, FAQ and the meta
// description). Under the hero, on the same background, come the customer
// static band of audit figures (ProofStrip; its top shows at the bottom of
// the first screen) and then, under a rule and a heading of its own, the
// customer logo band.
const BannerSection = () => (
  <BannerWrapper id="banner_section">
    <HeroStage>
      <HeroGrid>
        <div className="hero_copy">
          {/* The brand line reads in full from the top: the small kicker
              "See. Understand." sits over the heading, which stays the result
              (heading navigation and search see "Reduce AWS costs. Typical
              savings: 13-44%."). Only the figure is gold, in the light of See
              in action. */}
          <p className="hero_kicker">See. Understand.</p>
          <h1>
            <span>Reduce AWS costs.</span>{" "}
            <span className="hero_result">
              Typical savings: <span className="hero_gold">13–44%</span>
            </span>
          </h1>
          <p className="hero_lead">
            Identified in AWS cost audits run with CloudPouch, a desktop app
            that keeps data local. <CasesLink />
          </p>
          <div className="hero_action">
            <TrialDownloadButton buttonStyle={HERO_BUTTON} location="hero" />
            <SeeInAction />
            <p className="hero_reassure">
              <span>7-day Pro trial</span> <i aria-hidden="true">·</i>{" "}
              <span>No credit card</span>
            </p>
          </div>
        </div>
        {/* HERO_VIDEO (common/data/launch.js) switches the placeholder to
            the film. It starts muted and plays once (HeroVideo); controls
            let the visitor pause and turn the sound on. The description must
            match the film; screen readers get it, the picture speaks for
            itself. */}
        <HeroMedia className="hero_media">
          {HERO_VIDEO ? (
            <HeroVideo
              src={HERO_VIDEO.src}
              poster={HERO_VIDEO.poster}
              captions={HERO_VIDEO.captions}
              label="CloudPouch 2.0 product video"
              describedBy={VIDEO_DESCRIPTION_ID}
            />
          ) : (
            <MediaPlaceholder
              kind="video"
              label="CloudPouch 2.0 premiere film, 32 seconds, 16:9"
              file="cloudpouch-2-premiere-1920x1080.mp4"
            />
          )}
          {HERO_VIDEO && (
            <figcaption id={VIDEO_DESCRIPTION_ID} className="sr-only">
              CloudPouch 2.0 in under a minute: all your AWS profiles and AWS SSO,
              a Savings Scan that finds waste, and your AI assistant answering
              cost questions.
            </figcaption>
          )}
        </HeroMedia>
      </HeroGrid>
    </HeroStage>
    <ProofStrip />
    <CustomerLogosSection onHero />
  </BannerWrapper>
);

export default BannerSection;
